export default "__VITE_ASSET__DPf4tUnr__"